import {
    FETCH_PLAN_SUMMARY_LOADING,
    FETCH_PLAN_SUMMARY_SUCCESS,
    FETCH_PLAN_SUMMARY_FAILED,
  } from "../types";
  
  const initialState = {
    data: null,
    loading: false,
    error: null,
  };
  
  const planSummaryReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case FETCH_PLAN_SUMMARY_LOADING:
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case FETCH_PLAN_SUMMARY_SUCCESS:
        return {
          ...state,
          loading: false,
          data: action.payload,
        };
  
      case FETCH_PLAN_SUMMARY_FAILED:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default planSummaryReducer;
  